import {InputRefDirective} from './../common/input-ref.directive';
import {ChangeDetectorRef, Component, OnInit, ContentChild, TemplateRef} from '@angular/core';
import * as Quagga from 'quagga';

@Component({
  selector: 'ngx-barcode-input',
  template: `<div style="float: left;">
  <input type="text" name="barcode" ([ngModel])="barcode" [value]="barcode" placeholder="Barcode Input" autocomplete="off">
  <input type="file" id="file" name="file" class="inputfile" accept="image/*" capture="environment" (change)="onChange($event)">
  <button type="button" style="padding: 4px 4px 0 4px; line-height: 1em;"><label for="file"><span>Take a photo</span></label></button>
</div>

<div style="clear: both;"></div>
<div id="interactive" class="viewport"></div>
`,
  styles: [`#interactive.viewport{width:300px;height:300px;overflow:hidden;padding-top:15px}#interactive.viewport canvas,video{margin-top:-50px;width:300px;height:400px}#interactive.viewport canvas.drawingBuffer,video.drawingBuffer{margin-left:-300px}.inputfile{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.inputfile+button,.inputfile+label{cursor:pointer}`]
})
export class NgxBarcodeInputComponent implements OnInit {

  @ContentChild(InputRefDirective)
  input: InputRefDirective;

  public barcode = '';

  constructor(private ref: ChangeDetectorRef) { }

  ngOnInit() { }

  private onProcessed(result: any) {
    const drawingCtx = Quagga.canvas.ctx.overlay;
    const drawingCanvas = Quagga.canvas.dom.overlay;

    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')));
        result.boxes.filter(function (box) {
          return box !== result.box;
        }).forEach(function (box) {
          Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: 'green', lineWidth: 2});
        });
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: '#00F', lineWidth: 2});
      }

      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
      }
    }
  }

  onChange(e) {
    if (e.target.files && e.target.files.length) {
      Quagga.onProcessed((result) => this.onProcessed(result));

      Quagga.onDetected((result) => this.detectedBarcode(result));

      this.onDecodeSingle(URL.createObjectURL(e.target.files[0]));
    }
  }

  onDecodeSingle(img_src) {
    const config = {
      locate: true,
      locator: {
        patchSize: 'medium',
        halfSample: true
      },
      decoder: {
        readers: ['code_128_reader']
      },
      src: img_src
    };

    // Promisify DecodeSingle method from Quagga
    return new Promise((resolve, reject) => {
      Quagga.decodeSingle(config, result => {
        if (!result || typeof result.codeResult === 'undefined') {
          reject('Barcode Cannot be Decoded, Please Try a Valid Barcode and/or a Clear Photo of Barcode');
        } else {
          resolve(result.codeResult.code);
        }
      });
    }).catch((error) => {
      console.error(error);
      alert(error);
    });
  }

  detectedBarcode(result) {
    this.barcode = result.codeResult.code;
  }

}
